<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="isShowDetail ? 'd-none' : ''"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
>
  <div class="card-toolbar" before-btns>
    <!-- excel btn -->
    <button
      [disabled]="(items$ | async)?.length == 0"
      (click)="onExcelReport()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'common.downloadExcel' | translate"
    >
      <i class="mdi mdi-download mdi-20px tw-p-0 text-info"></i>
    </button>
  </div>

  <!-------------------------------------- Table Content ----------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let itemP of items$ | async; let i = index">
      <ng-container *ngFor="let item of itemP.items; let j = index">
        <tr
          #row
          (click)="onActiveRow(row, i)"
          [attr.data-group]="i"
          [attr.data-parent]="j == 0"
          [class.d-none]="j > 0"
          [class.row-active]="rowIndexSelected == i"
        >
          <!-- index -->
          <td class="tw-text-center !tw-p-4">
            <span [class.d-none]="j != 0">
              {{ paginationModel?.firstIndex + i }}
            </span>

            <i
              (click)="onShowOtherRows(i)"
              [id]="'icon_' + i"
              *ngIf="itemP.items.length > 1 && j == 0"
              class="menu-btn tw-rounded-[5px] mdi mdi-plus-circle text-success mdi-20px tw-mx-2 tw-my-1 tw-cursor-pointer"
            ></i>
          </td>

          <!-- userName -->
          <td class="tw-py-3">
            <td-value copyToClipboard [value]="item?.userName"></td-value>
          </td>

          <!-- organizationName -->
          <td class="tw-py-3">
            <td-value
              copyToClipboard
              [value]="item?.organizationName"
            ></td-value>
          </td>

          <!-- amount -->
          <td class="tw-py-3">
            <td-value
              copyToClipboard
              type="number"
              [value]="item?.amount"
            ></td-value>
          </td>

          <!-- currentCredit -->
          <td class="tw-py-3">
            <span
              copyToClipboard
              [class]="fontSize == 'sm' ? 'tw-text-[11px]' : 'tw-text-[12px]'"
              [credit]="item?.currentCredit"
              >{{ item?.currentCredit | numberSeparator }}</span
            >
          </td>

          <!-- typeTransaction -->
          <td class="dir-ltr tw-py-3">
            <span>
              <i
                [transactionTypeIcon]="item?.typeTransaction"
                [matTooltip]="
                  item?.typeTransaction
                    | enumToText : TypeTransactionsEnumValues
                "
              ></i>
            </span>
          </td>

          <!-- typeCreditChange -->
          <td class="dir-ltr tw-py-3">
            <span>{{
              item?.typeCreditChange | enumToText : TypeCreditChangesEnumValues
            }}</span>
          </td>

          <!-- outboxId -->
          <td class="tw-py-3">
            <td-value copyToClipboard [value]="item?.outboxId"></td-value>
          </td>

          <!-- paymentId -->
          <td class="tw-py-3">
            <span
              copyToClipboard
              [class]="fontSize == 'sm' ? 'tw-text-[11px]' : 'tw-text-[12px]'"
              >{{ item?.paymentId | checkValueLessThanZero }}</span
            >
          </td>

          <!-- description -->
          <td
            class="msg-summary tw-text-center"
            [ngClass]="{
              ' tw-cursor-pointer': item?.description
            }"
          >
            <div
              class="tw-flex-center"
              textPopover
              [parentSelector]="tagName"
              [fullText]="item?.description"
              [hidePopover]="
                !showParent ||
                pageConfig?.isVisibleHelpPage ||
                pageConfig?.isVisibleAuditPage
              "
            >
              <p
                class="tw-text-gray-500 dark:!tw-text-gray-200 tw-font-normal max-one-row tw-w-[100px] tw-min-w-[100px]"
              >
                {{ item?.description | checkValue }}
              </p>
            </div>
          </td>

          <!-- created -->
          <td class="tw-py-3">
            <td-value
              type="dateTimeWithSpace"
              [value]="item?.createdAt"
            ></td-value>
          </td>

          <!------------------------------- operations -------------------------------->
          <!-- detail -->
          <td class="sticky-td">
            <a
              (click)="onDetail(item.id)"
              class="btn btn-sm tw-ml-3"
              matTooltip="{{ 'common.showDetails' | translate }}"
            >
              <i class="mdi mdi-text-box-search-outline mdi-20px text-info"></i>
            </a>
          </td>
        </tr>
      </ng-container>
    </ng-container>
    <tr class="tw-py-2 total-sum" *ngIf="!this.pageConfig.isEmpty">
      <td
        class="tw-pr-[15px] ltr:tw-pl-[15px] tw-text-center !tw-py-3 tw-text-gray-600"
        colspan="3"
      >
        {{ "common.totalSum" | translate }}
      </td>
      <td
        class="tw-pr-[15px] ltr:tw-pl-[15px] tw-text-center tw-text-gray-800 tw-font-medium"
      >
        {{ totalSum | numberSeparator }}
      </td>
      <td
        class="tw-pr-[15px] ltr:tw-pl-[15px] tw-text-center"
        colspan="12"
      ></td>
    </tr>
  </ng-container>
</app-page-template>

<!-- Audit -->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    [sortReferenceId]="false"
    [hideReferenceId]="true"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--detail-->
<ng-container *ngIf="isShowDetail">
  <app-resellers-organization-transactions-detail
    [TypeCreditChangesEnumValues]="TypeCreditChangesEnumValues"
    [TypeTransactionsEnumValues]="TypeTransactionsEnumValues"
    [model]="detailModel"
    (closePage)="onCloseDetail()"
  >
  </app-resellers-organization-transactions-detail>
</ng-container>

<!--------------------------------------- help ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'resellerOrganizationTransactions'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
